package com.narbase.letsgo.web.views.banners


import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.weightOf
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.dimen
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.dimensions.vh
import com.narbase.kunafa.core.drawable.Color
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.dto.banners.BannerDto
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.animation.errorShake
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.verticalFiller
import com.narbase.letsgo.web.utils.views.*
import com.narbase.letsgo.web.utils.views.customViews.CustomCheckBox
import com.narbase.letsgo.web.utils.views.customViews.customCheckBox
import com.narbase.letsgo.web.views.templates.EntriesStyles.textInputStyle

class UpsertBannerDialog(private val onUpdated: () -> Unit) {
    private var dtoToEdit: BannerDto? = null
    private val popUp = popUpDialog { }

    private var errorTextView: TextView? = null
    private val viewModel = BannersManagementViewModel()

    private var imageContainer: LinearLayout? = null
    private var imageUploader: ImageUploader? = null
    private var titleTextInput: TextInput? = null
    private var descriptionTextArea: TextArea? = null
    private var isActiveCheckBox: CustomCheckBox? = null

    private fun upsertDialog() {
        viewModel.getBanners()
        theme.showDialog(popUp) { dialogBuilder ->
            verticalLayout {
                id = "upsertBannerRootView"
                style {
                    height = wrapContent
                    minWidth = 800.px
                    width = matchParent
                    backgroundColor = Color.white
                    borderRadius = 8.px
                }
                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    theme.bigTextView(this) {
                        text = if (dtoToEdit == null) "Add banner".localized() else "Edit banner".localized()
                    }
                    horizontalFiller()

                }
                verticalFiller(16)

                horizontalLayout {
                    style {
                        width = matchParent
                        maxHeight = 60.vh
                    }
                    verticalLayout {
                        style {
                            width = weightOf(1)
                            height = 60.vh
                        }
                        var inputsView: LinearLayout? = null
                        fun showInputs() {
                            inputsView?.apply {
                                clearAllChildren()

                                titleTextInput = theme.labeledTextInput(
                                    this, "Title".localized()
                                ) {
                                    text = dtoToEdit?.title ?: ""
                                }
                                descriptionTextArea =
                                    theme.labeledTextArea(
                                        this, "Description".localized()
                                    ) {
                                        text = dtoToEdit?.description ?: ""
                                    }

                                isActiveCheckBox = customCheckBox(
                                    "is banner active".localized(), isSelected = dtoToEdit?.isActive ?: false
                                )
                            }
                        }

                        inputsView = verticalLayout { style { width = matchParent } }
                        showInputs()

                        imageContainer = verticalLayout {
                            style {
                                width = matchParent
                            }
                            theme.label(this, "Background image".localized(), isRequired = false)
                            imageUploader = imageUploader(defaultImageUrl = dtoToEdit?.backgroundUrl) {

                            }
                        }
                    }
                }

                verticalFiller(8.px)
                errorTextView = textView {
                    style {
                        marginBottom = 8.px
                        fontSize = 14.px
                        color = AppColors.redLight
                        padding = 20.px
                    }
                    isVisible = false
                }

                dialogBuilder.bottomBar = {
                    horizontalLayout {
                        style {
                            width = matchParent
                            height = wrapContent
                            justifyContent = JustifyContent.End
                        }
                        theme.unimportantButton(this) {
                            text = "Dismiss".localized()
                            onClick = {
                                popUp.dismissDialog()
                            }

                        }

                        horizontalFiller(16)

                        val saveButton = theme.mainButton(this) {
                            text = "Save".localized()
                            id = "SaveButton"
                            onClick = {
                                onSaveButtonClicked()
                            }
                        }
                        viewModel.upsertUiState.clearObservers()
                        saveButton.withLoadingAndError(viewModel.upsertUiState,
                            onRetryClicked = {
                                onSaveButtonClicked()
                            },
                            onLoaded = {
                                popUp.dismissDialog()
                                onUpdated()
                            }
                        )
                    }

                }
            }
        }

    }

    private fun onSaveButtonClicked() {
        val imageUrl = imageUploader?.imageUrl?.ifBlank { null }
        val title = titleTextInput?.validateAndGetText()
        val description = descriptionTextArea?.validateAndGetText()
        val isActive = isActiveCheckBox?.isSelected ?: false
        if (title.isNullOrBlank() && description.isNullOrBlank() && imageUrl == null) {
            titleTextInput?.errorShake()
            descriptionTextArea?.errorShake()
            errorTextView?.text = "Please provide a title, a description or an image".localized()
            errorTextView?.isVisible = true
            isDataValid = false
            return
        }
        errorTextView?.text = ""
        errorTextView?.isVisible = false
        val banner = BannerDto(
            id = dtoToEdit?.id,
            title = title ?: "",
            description = description ?: "",
            backgroundUrl = imageUrl,
            isActive = isActive
        )
        viewModel.upsertItem(banner)
        isDataValid = true
    }

    private var isDataValid = false

    private fun TextInput?.validateAndGetText(): String {
        val text = this?.text ?: ""
        if (text.isBlank()) {
            isDataValid = false
            this?.addErrorStyle()
        } else {
            this?.resetStyle()
        }
        return text
    }

    private fun TextArea?.validateAndGetText(): String {
        val text = this?.text ?: ""
        if (text.isBlank()) {
            isDataValid = false
            this?.addErrorStyle()
        } else {
            this?.resetStyle()
        }
        return text
    }



    private fun View.addErrorStyle() {
        removeRuleSet(textInputStyle)
        addRuleSet(textInputErrorStyle)
    }

    private fun View.resetStyle() {
        removeRuleSet(textInputErrorStyle)
        addRuleSet(textInputStyle)
    }

    fun add() {
        dtoToEdit = null
        upsertDialog()
    }

    fun edit(dto: BannerDto) {
        dtoToEdit = dto
        upsertDialog()
    }

    private val textInputErrorStyle = classRuleSet {
        padding = 4.px
        fontSize = 14.px
        padding = "6px 12px".dimen()
        border = "1px solid ${AppColors.redLight}"
        borderRadius = 4.px
    }
}
